export default "__VITE_ASSET__Fhn4E5fp__"